module.exports = __webpack_public_path__ + "static/media/background1.7f26e599.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background1.jpg
// module id = 710
// module chunks = 21